import { useMemo } from 'react';
import { useCosmosEditorial } from 'providers/contexts/CosmosEditorialContext';

type RawArticleType = {
  label: string;
  id: string;
};

type ArticleType = {
  label: string;
  value: string; // mapped from id
};

export const useArticleTypes = () => {
  const { editorialConfig } = useCosmosEditorial();

  const articleTypes = useMemo<ArticleType[]>(() => {
    const rawTypes = editorialConfig?.article_types;

    return (
      rawTypes
        ?.filter(
          (t: any): t is RawArticleType =>
            typeof t.label === 'string' && typeof t.id === 'string',
        )
        .map((t) => ({ label: t.label, value: t.id })) ?? []
    );
  }, [editorialConfig]);

  // Map from label: id (for reverse mapping on submit)
  const labelToIdMap = useMemo<Record<string, string>>(() => {
    const map: Record<string, string> = {};
    articleTypes.forEach((t) => {
      map[t.label] = t.value;
    });
    return map;
  }, [articleTypes]);

  return { articleTypes, labelToIdMap };
};
